export enum HormoneValueType {
  LH = 'lh',
  PG = 'pg',
  LR_E3G = 'lr_e3g',
}
